import Triggerable from "metabase/components/Triggerable";
import Popover from "metabase/components/Popover";

export default Triggerable(Popover);
